module.exports = __webpack_public_path__ + "media/img/logo-white-5c131081395c7aa10dcbb92c91a2069d.svg";